// actions to perform in redux store
export const GET_LOCAL_DATA = "get-local-data"
export const ADD_HABBIT = "add-habbot"
export const UPDATE_HABBIT = "update-habbit"
export const UPDATE_APP_DAILY = "update-app-daily"
export const DELETE_HABBIT = "delete-habbit"
